import React from 'react';

function TimeExpiredModal({ onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-surface rounded-lg shadow-xl w-full max-w-md mx-4">
        <div className="p-6 text-center">
          <div className="w-16 h-16 mx-auto mb-4 bg-error-subtle rounded-full flex items-center justify-center">
            <svg className="w-8 h-8 text-error" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h3 className="text-xl font-semibold text-content mb-2">
            Temps Esgotat
          </h3>
          <p className="text-content-secondary mb-4">
            El temps assignat per a aquest exercici ha finalitzat.
          </p>
          <div className="bg-surface-subtle rounded-lg p-4 mb-4">
            <p className="text-sm text-content-secondary">
              L'exercici s'ha enviat automàticament amb l'estat actual del teu treball.
            </p>
          </div>
          <p className="text-sm text-content-muted mb-6">
            Ara pots revisar el teu treball en mode de només lectura.
          </p>
          <button
            onClick={onClose}
            className="w-full px-4 py-2 bg-accent text-white rounded-lg hover:bg-accent-hover"
          >
            Entès
          </button>
        </div>
      </div>
    </div>
  );
}

export default TimeExpiredModal;
